// eslint-disable-next-line import/extensions
import useLatestCallback from './lib/src/index.js';

export default useLatestCallback;
